<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :form="form"
    :title="$t('model.user')"
    resource="users"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { MEMBER_USER_TYPES } from '@/constants';

@Component
export default class User extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'screen_name_cont',
        label: this.$t('user.screenName'),
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'member_name_cont',
        label: this.$t('member.name'),
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'member_user_type_eq',
        label: this.$t('member.userType'),
        renderCell: {
          component: 'select',
          props: {
            options: _.map(MEMBER_USER_TYPES, (v) => ({ label: this.$t(`member.userTypes.${v}`), value: v })),
            clearable: true
          }
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
        sortable: true
      },
      {
        prop: 'avatar',
        label: this.$t('user.avatar'),
        width: 150,
        renderCell: {
          component: 'storageAttachment',
          props: {
            borderRadius: '50%'
          }
        }
      },
      {
        prop: 'screen_name',
        label: this.$t('user.screenName'),
        renderCell: {
          component: (h, { props: { value, scope: { row } } }) => {
            if (row.sns_authorized) {
              return (<span>{value}</span>)
            } else {
              return <el-tag type='info'>{this.$t('unauthorized')}</el-tag>;
            }
          }
        }
      },
      {
        prop: 'member',
        label: this.$t('user.member'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'members.show', params: { id: value.id } }}>{_.get(value, 'name', value.id)}({this.$t(`member.userTypes.${value.user_type}`)})</bean-link>
          } else {
            return <span>/</span>
          }
        }
      },
      type === 'show' && {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      type === 'show' && {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/users',
    name: 'users.index',
    component: User,
    props: {
      type: 'index',
    }
  },
  {
    path: '/users/:id',
    name: 'users.show',
    component: User,
    props: {
      type: 'show',
    }
  }
]
</script>
